import type { QBankStructureLevel } from '@exam-management/qbs-provider';
import { randomUUID } from '@shared/utils';

import type { QBSLevelItemExcludingTag } from '../types';

import { findNextEnabledLevel } from './find';

export function createQBankStructureLevelItem(
  parentLevelItemId: string,
  levelItems: QBSLevelItemExcludingTag[],
  levels: QBankStructureLevel[],
  qBankStructureId: string,
) {
  const parentLevelItem = levelItems.find((item) => {
    return item.id === parentLevelItemId;
  });

  const parentLevelId = parentLevelItem?.qBankStructureLevelId;
  if (!parentLevelId) {
    return null;
  }

  const nextQBankStructureLevel = findNextEnabledLevel(levels, parentLevelId);
  if (!nextQBankStructureLevel) {
    return null;
  }

  const childLevelItems = levelItems.filter((item) => {
    return item.parentLevelItemId === parentLevelItemId;
  });

  const order =
    childLevelItems.length > 0 ? Math.max(...childLevelItems.map((item) => item.order)) + 1 : 1;

  return {
    id: randomUUID(),
    qBankStructureId,
    parentLevelItemId,
    order,
    qBankStructureLevelId: nextQBankStructureLevel.id,
    qBankStructureLevel: nextQBankStructureLevel,
    isNew: true,
  } as QBSLevelItemExcludingTag;
}
